import React, {
  useCallback, useEffect, useState, createRef,
} from 'react';
import * as Styles from './DomainsListHandler.styles';
import DomainItem from './components/DomainItem';
import shortid from 'shortid';
import { useDispatch, useSelector } from 'react-redux';
import { DOMAIN_STATUS, domainsChips } from './DomainsListHandler.types';
import {
  Button, PageTitle, Skeleton,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import { loadFaqDomainList } from '@/redux/actions/faq';
import { SUPPORT_DOMAINS_URL } from '@/config/urls/domainsUrls';
import FaqDefault from '@/components/FrequentlyQuestions/FaqDefault';
import { useBillingStatus } from '@/hooks/domains/useBillingStatus';
import { GET_A_NEW_DOMAIN } from '@/config/urls/supportUrls';
import { domainsActions } from '@/redux/modules';
import { TitanTrialBanner } from './components/TitanTrialBanner';
import { BannerDomainRegisterHandler } from './components/BannerDomainRegisterHandler';
import { ESSENTIALS_PLAN } from '@/components/Email/TitanUpgrade/TitanUpgradePlanItem/TitanPlans';
import { requestUpgradePlans } from '@/redux/actions/emails';
import { isBRServer } from '@/utils/Validators/validation';
import { Popover } from '@/components/Popover';
import { PopoverContent } from '@/components/Popover/PopoverContent';
import {
  ATIVACAO_BUY_DOMAIN_FLOW,
  ATIVACAO_RESGATE_DOMINIO_GRATUITO,
  AI_AGENTS_DOMAINS_PAGE,
} from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useHistory } from 'react-router';

let changeFilterTimeout = null;
const DomainsListHandler = () => {
  const history = useHistory();
  const { domains: domainsLocale, routes: routesLocale } = useLocale();
  const domainsListLocale = domainsLocale.domainsListPage;
  const defaultFilterOptions = domainsChips.map(chip => ({ ...chip, label: domainsListLocale.filter[chip.value] }));

  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);
  const [filterOptions, setFilterOptions] = useState(defaultFilterOptions);
  const [selectedChip, setSelectedChip] = useState(defaultFilterOptions[0]);
  const [domainFilter, setDomainFilter] = useState('');
  const [domainsListFiltered, setDomainsListFiltered] = useState([]);
  const [essentialData, setEssentialData] = useState({ name: '', price: '' });
  const [page, setPage] = useState(1);
  const [justUpdated, setJustUpdate] = useState(false);
  const guideRef = createRef(null);
  const showRedeemFreeDomainGrowthbook = useFeatureIsOn(ATIVACAO_RESGATE_DOMINIO_GRATUITO);
  const showAIAgentBanner = useFeatureIsOn(AI_AGENTS_DOMAINS_PAGE);
  const buyDomainEnabled = useFeatureIsOn(ATIVACAO_BUY_DOMAIN_FLOW);

  const {
    loading: loadingDomains,
    list: domains,
    listTotal,
    domainsElegible,
    redeemAvailability,
  } = useSelector(state => state.newDomains);
  const faq = useSelector(state => state.faq);
  const allEmails = useSelector(state => state.emails.proEmailList);
  const { isIframeOpen } = useSelector(state => state.merlin);

  let domainWithoutEmail = allEmails.filter(item => item.type === 'domain' && !!item.domain && item.status === 'Active');
  if (domainsElegible.length) {
    domainWithoutEmail = domainsElegible.filter(item => item.status === 'Active');
  }

  const dispatch = useDispatch();
  const { getTagStatus } = useBillingStatus();

  const emptyList = domainsListFiltered.length === 0;

  const handleShowLoadMoreButton = useCallback(() => {
    if (domains.length < listTotal) {
      setShowLoadMoreButton(true);
      return;
    }

    setShowLoadMoreButton(false);
  }, [
    listTotal,
    domains,
  ]);

  const loadMore = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  const filterDomain = useCallback(() => {
    let newDomainsList = [...domains];

    if (!domainFilter && selectedChip.value === 'all') {
      setDomainsListFiltered([...domains]);
    }

    if (domainFilter) {
      newDomainsList = domains.filter(product => product.domain.includes(domainFilter));
    }

    if (selectedChip && selectedChip.value !== 'all') {
      const pendingStatus = [
        DOMAIN_STATUS.PENDING,
        DOMAIN_STATUS.EXPIRED,
        DOMAIN_STATUS.OVERDUE_DATE,
        DOMAIN_STATUS.NEXT_DUE_DATE,
      ];

      switch (selectedChip.value) {
        case 'billingPending':
          newDomainsList = newDomainsList.filter(domain => pendingStatus.includes(getTagStatus(domain)));
          break;
        case 'registerFail':
          newDomainsList = newDomainsList.filter(domain => domain.status === DOMAIN_STATUS.REGISTER_ERROR);
          break;
        default:
      }
    }
    setDomainsListFiltered(newDomainsList);
  }, [domainFilter, selectedChip, domains, getTagStatus]);

  const handleTypeFilter = (text) => {
    clearTimeout(changeFilterTimeout);
    changeFilterTimeout = setTimeout(() => {
      setDomainFilter(text);
      setJustUpdate(false);
    }, 500);
  };

  const getFilterProps = () => {
    const clearOptions = () => {
      const newOptions = [...filterOptions].map((option) => {
        const newOption = { ...option };
        newOption.checked = false;
        return newOption;
      });

      return newOptions;
    };

    const handleChangeChip = (chip) => {
      const newOptions = clearOptions();
      const chipIndex = newOptions.findIndex(option => option.id === chip.id);

      if (!chipIndex) {
        newOptions[0].checked = true;
        setSelectedChip(newOptions[0]);
      }

      if (chipIndex) {
        newOptions[chipIndex].checked = true;
        setSelectedChip(newOptions[chipIndex]);
      }

      setFilterOptions(newOptions);
    };

    const handleClearFilter = () => {
      setDomainFilter('');
      setFilterOptions(defaultFilterOptions);
      setSelectedChip(defaultFilterOptions[0]);
    };

    const handleChangeFilterBy = (text) => {
      handleTypeFilter(text);
    };

    const headButton = {
      label: buyDomainEnabled ? (
        <>
          {domainsListLocale.newDomainLabel}
        </>
      ) : domainsListLocale.contractNewButtonLabel,
      fullWidthHead: buyDomainEnabled,
      buttonVariant: buyDomainEnabled ? 'primary' : 'secondary',
      buttonSize: 'medium2',
      onClick: () => {
        if (buyDomainEnabled) {
          history.push(`${routesLocale.domains}${routesLocale.buyDomain}`);
        }

        if (!buyDomainEnabled) {
          window.open(GET_A_NEW_DOMAIN);
        }
      },
    };

    const defaultProps = {
      testId: 'domains-list',
      title: domainsListLocale.filter.title,
      filterLabel: domainsListLocale.filter.filterLabel,
      filterByPlaceholder: domainsListLocale.filter.search,
      filterByValue: domainFilter,
      clearFilterLabel: domainsListLocale.filter.clearLabel,
      filterChips: filterOptions,
      hideFilter: false,
      headButton,
      handleClearFilter,
    };

    return {
      ...defaultProps,
      handleChangeChip,
      handleChangeFilterBy,
    };
  };

  const getDataOfEssential = useCallback(() => dispatch(
    requestUpgradePlans(),
  ).then(({ data }) => {
    const [planData] = data.filter(plan => plan.id === ESSENTIALS_PLAN);
    if (planData) {
      const { name, configoptions } = planData;
      const [{ monthly: price }] = configoptions;

      const dataEssential = { name, price };

      if (isBRServer) {
        dataEssential.price = price.replace('.', ',');
      }

      setEssentialData(dataEssential);
    }
  }), [dispatch]);

  const requestDataOfEssential = useCallback(() => {
    if (domainWithoutEmail.length > 0 && essentialData.price === '') {
      getDataOfEssential();
    }
  }, [getDataOfEssential, domainWithoutEmail.length, essentialData.price]);

  const requestFaqDomainList = useCallback(() => {
    dispatch(loadFaqDomainList());
  }, [dispatch]);

  useEffect(() => {
    requestDataOfEssential();
  }, [requestDataOfEssential]);

  useEffect(() => {
    filterDomain();
  }, [filterDomain]);

  useEffect(() => {
    handleShowLoadMoreButton();
  }, [handleShowLoadMoreButton]);

  useEffect(() => {
    dispatch(domainsActions.domainsElegible.get());
  }, [dispatch]);

  useEffect(() => {
    dispatch(domainsActions.domains.request({ page }));
  }, [dispatch, page]);

  useEffect(() => {
    requestFaqDomainList();
  }, [requestFaqDomainList]);

  const mountLoading = (
    <Styles.LoadingWrapper>
      <Skeleton variant="tableSimple" />
    </Styles.LoadingWrapper>
  );

  const loadMoreButton = () => showLoadMoreButton && (
  <Styles.LoadMoreWrapper>
    <Button testId="load-more-button" label={domainsListLocale.loadMoreButtonLabel} onClick={loadMore} variant="secondary" />
  </Styles.LoadMoreWrapper>
  );

  const mountEmptyState = label => (
    <Styles.EmptyStateWrapper>
      <Styles.EmptyStateLabel>
        {label}
      </Styles.EmptyStateLabel>
    </Styles.EmptyStateWrapper>
  );

  const requestNextPageWhenEmptyState = useCallback(() => {
    if (emptyList && domainFilter && domains.length < listTotal && !loadingDomains && !justUpdated) {
      setPage(page + 1);
      setJustUpdate(true);
    }
  }, [emptyList, page, domains.length, listTotal, domainFilter, loadingDomains, justUpdated]);

  useEffect(() => {
    requestNextPageWhenEmptyState();
  }, [requestNextPageWhenEmptyState]);

  const getRedeemAvailabilityDomains = useCallback(() => {
    if (redeemAvailability && !redeemAvailability.loaded) {
      dispatch(domainsActions.redeemAvailability.request());
    }
  }, [dispatch, redeemAvailability]);

  useEffect(() => {
    if (showRedeemFreeDomainGrowthbook) {
      getRedeemAvailabilityDomains();
    }
  }, [getRedeemAvailabilityDomains, showRedeemFreeDomainGrowthbook]);

  const getBannerDomainRegisterHandlerProps = useCallback(() => ({
    locales: domainsLocale,
    loaded: redeemAvailability && redeemAvailability.loaded,
    redeemAvailability,
  }), [domainsLocale, redeemAvailability]);

  const reedemAvailabilityDomainsLength = redeemAvailability && redeemAvailability.domains.length;
  const showRedeemFreeDomain = reedemAvailabilityDomainsLength > 0 && showRedeemFreeDomainGrowthbook;

  const getPopoverProps = useCallback(() => ({
    title: domainsListLocale.popover.title,
    description: domainsListLocale.popover.description,
    buttonLabel: domainsListLocale.popover.buttonLabel,
  }), [domainsListLocale.popover]);

  const popoverContent = <PopoverContent {...getPopoverProps()} />;

  const steps = [
    {
      popover: {
        key: 'domainsBannerButton',
        content: popoverContent,
        pointer: 'topRight',
        $maxWidth: 240,
      },
      mask: {
        customRadius: 100,
      },
    },
  ];

  const popoverStorageKey = 'notShowDomainsBannerPopover';
  const notShowBannerPopover = localStorage.getItem(popoverStorageKey) || isIframeOpen || !showAIAgentBanner;

  return (
    <>
      <Styles.Wrapper>
        {!notShowBannerPopover && <Popover steps={steps} guideRef={guideRef} storageKey={popoverStorageKey} />}
        <Styles.Section noPadding>
          <PageTitle {...getFilterProps()} />
        </Styles.Section>
        {showRedeemFreeDomain && (
        <Styles.Section noPadding noBackgroundColor>
          <BannerDomainRegisterHandler {...getBannerDomainRegisterHandlerProps()} />
        </Styles.Section>
        )}
        {!showRedeemFreeDomain && (
        <Styles.Section noPadding>
          <TitanTrialBanner domainWithoutEmail={domainWithoutEmail} essentialData={essentialData} />
        </Styles.Section>
        )}
        <Styles.Section>
          {loadingDomains ? mountLoading : (
            <>
              {domains.length === 0 ? mountEmptyState(domainsListLocale.emptyState) : (
                <>
                  {emptyList ? mountEmptyState(domainsListLocale.noFilterResult) : (
                    <Styles.DomainsList>
                      {domainsListFiltered.length > 0 && domainsListFiltered.slice(0, domainsListFiltered.length).map((domain, index) => (
                        <DomainItem firstItem={index === 0} domain={domain} statusTag={getTagStatus(domain)} key={shortid.generate()} />
                      ))}
                      {loadMoreButton()}
                    </Styles.DomainsList>
                  )}
                </>
              )}
            </>
          )}
        </Styles.Section>
        <FaqDefault
          questions={faq.domainList.questions}
          link={SUPPORT_DOMAINS_URL}
          loading={faq.loading}
        />
      </Styles.Wrapper>
    </>
  );
};

export default DomainsListHandler;
